import React, { useEffect, useState } from 'react';
import { T, serif, Boton, Campo, estiloInput, Aviso, Cargando } from '../lib/ui';

// ════════════════════════════════════════════════════════════════════
// Confirmar un borrado o una anulación
//
// El servidor decide cuál de las dos cosas corresponde; esta pantalla
// solo lo explica. La diferencia importa: borrar hace desaparecer el
// registro, anular lo conserva con el motivo. Si la persona no
// entiende cuál está haciendo, tarde o temprano borra algo que
// necesitaba.
// ════════════════════════════════════════════════════════════════════

export function ConfirmarEliminar({
  titulo, descripcion, consultar, ejecutar, onCerrar, onHecho,
}) {
  const [politica, setPolitica] = useState(null);
  const [motivo, setMotivo] = useState('');
  const [ocupado, setOcupado] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    consultar()
      .then(setPolitica)
      .catch(() => setPolitica({ accion: 'nada', motivo: 'No se pudo comprobar.' }));
  }, []);   // eslint-disable-line react-hooks/exhaustive-deps

  const confirmar = async () => {
    setOcupado(true);
    setError('');
    try {
      const r = await ejecutar(motivo.trim() || undefined);
      onHecho(r);
    } catch (err) {
      setError(err.detalle?.detalle || 'No se pudo completar.');
      setOcupado(false);
    }
  };

  const anula = politica?.accion === 'anular';
  const bloqueado = politica?.accion === 'nada';

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 140, background: 'rgba(10,15,26,.6)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 18,
    }} onClick={onCerrar}>
      <div onClick={(e) => e.stopPropagation()} style={{
        background: '#fff', borderRadius: 12, padding: 20,
        width: '100%', maxWidth: 420,
      }}>
        {!politica ? <Cargando /> : (
          <>
            <div style={{
              fontFamily: serif, fontSize: 19, fontWeight: 600,
              color: bloqueado ? T.muted : (anula ? T.warn : T.bad),
              marginBottom: 6,
            }}>
              {bloqueado ? 'No se puede eliminar'
                : anula ? `Anular ${titulo}` : `Eliminar ${titulo}`}
            </div>

            {descripcion && (
              <div style={{ fontSize: 13, color: T.tinta, marginBottom: 12 }}>
                {descripcion}
              </div>
            )}

            {politica.motivo && (
              <Aviso tipo={bloqueado ? 'info' : 'alerta'}>{politica.motivo}</Aviso>
            )}

            {!bloqueado && !anula && (
              <Aviso tipo="malo">
                Desaparece de la plataforma y no se puede recuperar. Queda el
                rastro en la auditoría, pero el registro no vuelve.
              </Aviso>
            )}

            {anula && (
              <Campo etiqueta="Motivo de la anulación"
                     ayuda="Queda guardado junto al registro. Sé concreto.">
                <textarea value={motivo} rows={3}
                          onChange={(e) => setMotivo(e.target.value)}
                          placeholder="Por ejemplo: se capturó dos veces por error"
                          style={{ ...estiloInput, resize: 'vertical' }} />
              </Campo>
            )}

            {error && <Aviso tipo="bad">{error}</Aviso>}

            <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
              <Boton variante="suave" onClick={onCerrar} disabled={ocupado}
                     style={{ flex: 1 }}>
                {bloqueado ? 'Entendido' : 'Cancelar'}
              </Boton>
              {!bloqueado && (
                <Boton variante="peligro" onClick={confirmar}
                       disabled={ocupado || (anula && !motivo.trim())}
                       style={{ flex: 1.3 }}>
                  {ocupado ? 'Un momento…' : (anula ? 'Anular' : 'Eliminar')}
                </Boton>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
